

import axios from "axios";
const instance = axios.create({ baseURL: "https://familiacantu-api.herokuapp.com" });
//const instance = axios.create({ baseURL: "http://localhost:8081" });

export default {
  state: {
    user: null,
    error: null,
    server: "https://familiacantu-api.herokuapp.com",
    loadingError: false,
    desconto: false
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setDesconto (state, payload) {
      state.desconto = payload;
    },
    setError (state, payload) {
      state.error = payload;
    }
  },
  actions: {
    async init ({commit}, payload) {
      
      /*firebase.getAuth().onAuthStateChanged((user) => {
        if (user) {
          commit('setUser', user)
        }
      })*/
      if (localStorage.getItem("clube-token")) {
        var token = localStorage.getItem("clube-token");
        var payload = JSON.parse(window.atob(token.split(".")[1]));
        commit("setUser", await payload);
      }
    },
    async signUserUp({ commit }, payload) {
      commit("setLoading", true);
      commit("clearError");
      await instance
        .post("/users/register", payload)
        .then(async user => {
          commit("setLoading", false);
          const newUser = {
            id: user.uid,
            name: payload.email,
            email: payload.email,
            photoUrl: user.photoURL
          };
          let userNew = JSON.parse(window.atob(user.data.token.split(".")[1]));
          localStorage.setItem("clube-token", user.data.token);
          commit("setUser", await userNew);
        })
        .catch(error => {
          commit("setLoading", false);
          commit("setError", error);
          console.log(error);
        });
      /*firebase.getAuth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )*/
    },
    async signUserIn({ commit }, payload) {
      commit("setLoading", true);
      commit("clearError");
      await instance
        .post("/users/login", payload)
        .then(async user => {
          commit("setLoading", false);
          const newUser = {
            id: user.uid,
            name: payload.email,
            email: payload.email,
            photoUrl: user.photoURL
          };
          let userNew = JSON.parse(window.atob(user.data.token.split(".")[1]));
          localStorage.setItem("clube-token", user.data.token);
          commit("setUser", await userNew);
        })
        .catch(error => {
          console.log(error);
          error = "Usuário ou senha invalido!";
          commit("setLoading", false);
          commit("setError", error);
          console.log(error);
        });

      /*firebase.getAuth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )*/
    },
    signUserInGoogle ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GoogleAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInFacebook ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().FacebookAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInGithub ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GithubAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInTwitter ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().TwitterAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      })
    },
    desconto ({commit}, payload) {
      commit("setDesconto", payload.val);
    },
    logout ({commit}) {
      localStorage.removeItem("clube-token");
      commit("setUser", null);
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    server(state) {
      return state.server;
    },
    desconto(state) {
      return state.desconto;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js